<template>
  <div class="ordersSearch">
    <div class="ordersSearch__field">
      <v-icon small class="ordersSearch__icon">mdi-magnify</v-icon>
      <input
        v-model="term"
        class="ordersSearch__input"
        type="text"
        placeholder="Order suchen — Nummer (z. B. 90353) oder Kunden-E-Mail…"
        @input="onInput"
        @keydown.esc="clear"
      />
      <v-progress-circular
        v-if="searching"
        indeterminate
        size="14"
        width="2"
        class="ordersSearch__spinner"
      />
      <v-btn v-if="term" icon x-small @click="clear">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { searchOrders } from "@/utils";

export default {
  name: "SearchHeader",
  data() {
    return {
      term: "",
      searching: false,
      debounceTimer: null,
    };
  },
  methods: {
    onInput() {
      clearTimeout(this.debounceTimer);
      const raw = this.term.trim();
      if (raw.length < 2) {
        this.$emit("results", null); // zurück zur normalen Liste
        return;
      }
      this.debounceTimer = setTimeout(this.runSearch, 350);
    },
    clear() {
      this.term = "";
      this.$emit("results", null);
    },
    async runSearch() {
      this.searching = true;
      try {
        this.$emit("results", await searchOrders(this.term.trim(), 50));
      } catch (e) {
        console.warn("order search failed:", e);
      } finally {
        this.searching = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ordersSearch {
  margin-bottom: 4px;

  &__field {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 999px;
    padding: 0 16px;
    height: 46px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 4px 14px rgba(16, 24, 40, 0.07);
    transition: box-shadow 0.15s;

    &:focus-within {
      box-shadow: 0 0 0 2px rgba(123, 92, 214, 0.35);
    }
  }
  &__icon {
    color: rgba(0, 0, 0, 0.4) !important;
    margin-right: 10px;
  }
  &__input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14.5px;
    color: rgba(0, 0, 0, 0.8);

    &::placeholder {
      color: rgba(0, 0, 0, 0.35);
    }
  }
  &__spinner {
    color: #7b5cd6;
    margin-right: 8px;
  }
}
</style>
